<template>
    <div class="dropdown">
        <button class="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            ATT Calendar Invite
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="#" @click="selectTargetDate('webOutlook')">Web Outlook</a>
<!--            <a class="dropdown-item" href="#" @click="selectTargetDate('ics')">iCal/Outlook</a>-->
            <a class="dropdown-item" href="#" @click="selectTargetDate('google')">Google</a>
            <a class="dropdown-item" href="#" @click="selectTargetDate('yahoo')">Yahoo</a>
        </div>
        <modal id="calendar-link-modal">
            <template slot="body">
                <p class="text-muted text-center mt-3">Select a target date.</p>
                <field-datetime v-model="target_date_time" label="Select Date &amp; Time" :inline="true"></field-datetime>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">
                    <i class="fa fa-times"></i> Cancel
                </button>
                <button class="btn btn-success" @click="download()">Download</button>
            </template>
        </modal>
    </div>
</template>
<script>
    export default {

        props:{
            project: {
                type: Object,
                required: true,
            }
        },

        data(){
           return {
               linkType: null,
               target_date_time: moment().format(),
           }
        },

        methods:{
            selectTargetDate(type){
                this.linkType = type;
                this.openModal('calendar-link-modal');
            },

            download(){
                this.redirectTo(`/projects/${this.project.slug}/calendar-link/${this.linkType}?date=${this.target_date_time}`, '_blank')
                this.closeModal('calendar-link-modal')
            }
        }
    }
</script>
